(function() {
  if (typeof window === 'undefined') return;
  if (typeof jQuery === 'undefined') return;

  var $ = jQuery;

  function updateSliderAccessibility($slider) {
    var $slides = $slider.find('.slick-slide');

    $slides.each(function() {
      var $slide = $(this);
      var active = !$slide.hasClass('slick-cloned') && $slide.hasClass('slick-active');

      $slide.attr('aria-hidden', active ? 'false' : 'true');

      $slide.find('a, button, input, [tabindex]').each(function() {
        var $el = $(this);
        if (active) {
          var prevTab = $el.data('tb-prev-tabindex');
          if (prevTab !== undefined) {
            $el.attr('tabindex', prevTab);
          } else {
            $el.removeAttr('tabindex');
          }
        } else {
          if (!$el.data('tb-prev-tabindex')) {
            $el.data('tb-prev-tabindex', $el.attr('tabindex') || 0);
          }
          $el.attr('tabindex', -1);
        }
      });
    });
  }


  function updateJudgeMeArrowLabels() {
    $('.jdgm-arrow').each(function() {
      var $arrow = $(this);
      var onclick = $arrow.attr('onclick') || '';
      var isNext = $arrow.hasClass('jdgm-next-arrow') || /next/i.test(onclick);
      var label = isNext ? 'Next review' : 'Previous review';
      $arrow.attr('aria-label', label);
      if (!$arrow.attr('title')) {
        $arrow.attr('title', label);
      }
    });
  }

  function attachSliderHandlers() {
    $('.slick-slider').each(function() {
      var $slider = $(this);

      if ($slider.data('tb-accessibility-init')) return;
      $slider.data('tb-accessibility-init', true);

      $slider.on('init reInit afterChange', function() {
        updateSliderAccessibility($slider);
      });

      if ($slider.hasClass('slick-initialized')) {
        updateSliderAccessibility($slider);
      }
    });
  }

  $(document).on('ready', function() { attachSliderHandlers(); updateJudgeMeArrowLabels(); });
  $(window).on('load', function() { attachSliderHandlers(); updateJudgeMeArrowLabels(); });
})();
